// extracted by mini-css-extract-plugin
export default {"root":"styles_root__aTZyH","sticky":"styles_sticky__SI3ad"};